import { render, staticRenderFns } from "./PersonSearchProfileDetails.vue?vue&type=template&id=2aefc4c6&scoped=true&"
import script from "./PersonSearchProfileDetails.vue?vue&type=script&lang=js&"
export * from "./PersonSearchProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonSearchProfileDetails.vue?vue&type=style&index=0&id=2aefc4c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefc4c6",
  null
  
)

export default component.exports